import { Controller } from '@hotwired/stimulus';

// Injects the cross-page selection (persisted in sessionStorage) as
// hidden `ids[]` inputs when a form is submitted, then clears the stored
// selection so a successful add doesn't leave stale state for the next visit.
//
// Extracted from the inline <script> in exhibitor/rep_leads/_table.html.erb
// (LRPO-4918). The select-all / per-row sessionStorage WRITES stay inline
// there because DataTables rewraps the table after Stimulus first binds and
// the row-checkbox targets don't track the moved nodes — that wiring has a
// real DataTables constraint. This submit handler has no such constraint: it
// binds to a form OUTSIDE the DataTable and only READS the stored selection.
//
// Usage:
//   form data-controller="selection-submit"
//        data-selection-submit-storage-key-value="repLeadsSelected:<ee_id>"
//        data-action="submit->selection-submit#injectIds"
//
// The storage key is passed as a value so the controller is namespace-agnostic
// and reusable on any page that persists a selection under its own key.
export default class extends Controller {
  static values = { storageKey: String };

  injectIds() {
    // Drop any row-level ids[] already in the form so the server sees ONLY
    // the cross-page selection, not just the rows visible at submit time.
    this.element
      .querySelectorAll("input[name='ids[]']")
      .forEach((el) => el.remove());

    this.readSelection().forEach((id) => {
      const hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'ids[]';
      hidden.value = id;
      this.element.appendChild(hidden);
    });

    this.clearSelection();
  }

  readSelection() {
    try {
      const raw = sessionStorage.getItem(this.storageKeyValue);
      return raw ? JSON.parse(raw) : [];
    } catch (_) {
      return [];
    }
  }

  clearSelection() {
    try {
      sessionStorage.removeItem(this.storageKeyValue);
    } catch (_) {
      /* sessionStorage disabled / full — nothing to clear */
    }
  }
}
